import { EditedVariablesDto } from "app/ApiClient";
import { LoadingState } from "types";

export type RecodeState = {
  recoding: LoadingState;
  recodedError?: string | null;

  editingBatch: LoadingState;
  editedBatchError?: string | null;
  editedBatchResult: EditedVariablesDto | null;
};

export const initialRecodeState: RecodeState = {
  recoding: LoadingState.idle,

  editingBatch: LoadingState.idle,
  editedBatchResult: null,
};
